export const tabletMinWidth = 740; // matches braid ANZ value
export const mobileMaxWidth = tabletMinWidth - 1;

export const mobileHeaderHeight = 70;
export const stickyNavigationBarHeight = 56;

export const backButtonHeight = 58;
export const filterSectionHeight = 138;
export const topSectionHeight = backButtonHeight + filterSectionHeight;
export const stickyFilterNavigationBarHeight = 88;
